import { useGetBillingUnitById } from '@dhl/mdp-api'
import { convertToBillingUnit } from '~/modules/billingunits/model'

export const useBillingUnit = (id: string | undefined) => {
  const { data: billingUnitDto, isFetching } = useGetBillingUnitById(id ?? '', { query: { enabled: !!id } })

  const billingUnit = billingUnitDto ? convertToBillingUnit(billingUnitDto) : undefined

  return { billingUnit, isLoading: isFetching }
}
